// import client, { noAuthClient } from '@/apis/client';
import { noAuthClient } from '@/apis/client';

// export const getUser = async () => {
// const { data } = await client.post('/users/get_user');
// // const { data } = await noAuthClient.post('/users/get_user');
// return data;
// };

export const login = async (email, password) => {
  const res = await noAuthClient.post('/users/login', {
    email,
    password,
  });

  return res;
};

export const logout = async () => {
  const res = await noAuthClient.post('/users/logout');

  return res;
};
